export default __webpack_public_path__ + "static/media/ChickenChowmein.e667c8ed.png";